import { Badge } from "~/components/ui/badge";

interface AccessBadgeProps {
  /** Resolved access-level label, or null to render nothing. */
  label: string | null;
}

/** Outlined pill showing a caller's access level. Domain components map their
 * own access enum to a label (and decide visibility), then pass it here. */
export function AccessBadge({ label }: AccessBadgeProps) {
  if (!label) {
    return null;
  }

  return (
    <Badge variant="outline" className="rounded-full">
      {label}
    </Badge>
  );
}
